import { useState, useEffect } from 'react'
import RichEditor from 'components/richEditor/RichEditor'
import Button from 'components/formElements/Button'
import DefaultSelect from 'components/formElements/DefaultSelect'
import { Link, useNavigate } from 'react-router-dom'
import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import { useDispatch, useSelector } from 'react-redux'
import { useRequest } from 'hooks/useRequest'
import { setProjects } from 'redux/features/projects/projectsSlice'
import useToast from 'hooks/useToast'
const CreateTask = () => {
	const [getProjects] = useRequest()
	const [getPriorities] = useRequest()
	const [getTypes] = useRequest()
	const [getStatuses] = useRequest()
	const [saveTicket] = useRequest()
	const { showToast } = useToast()
	const navigate = useNavigate()
	const [formData, setFormData] = useState({
		title: '',
		projectId: null,
		ticketPriorityId: null,
		ticketTypeId: null,
		ticketStatusId:null,
		description: ''
	})
	const [priorities, setPriorities] = useState()
	const [taskTypes, setTaskTypes] = useState()
	const [taskStatuses, setTaskStatuses] = useState()
	const { projects } = useSelector((state) => state)
	const dispatch = useDispatch()
	const { projectsData } = projects
	useEffect(() => {
		getProjects('/Project/GetAllProjects', { method: 'GET' }).then((res) => {
			if (res.data.ok) {
				dispatch(setProjects(res.data.result))
			}
		})
		getPriorities('/TicketPriority/GetAllTicketPriority', { method: 'GET' }).then((res) => {
			if (res.data.ok) {
				setPriorities(res.data.result)
			}
		})
		getTypes('/TicketType/GetAllTicketTypes', { method: 'GET' }).then(res => {
			if (res.data.ok) {
				setTaskTypes(res.data.result)
			}
		})
		getStatuses('/TicketStatus/GetAllTicketStatus', { method: 'GET' }).then(res => {
			if (res.data.ok) {
				setTaskStatuses(res.data.result)
			}
		})
	}, [])
	// const [imagesData, setImagesData, convert] = useFileReader()
	// const removeImg = (index) => {
	// 	setImagesData((prev) => [...prev.filter((e, i) => i != index)])
	// }
	// const handleImageChage = (e) => {
	// 	convert(e.target.files)
	// }
	const handleDropdownChange = (e) => {
		setFormData(prev => ({ ...prev, [e.name]: e.value }))
	}
	const handleSubmit = () => {
		if (!formData.title) {
			showToast('Lütfen Bir Başlık Girin','error')
		}else if (!formData.projectId) {
			showToast('Lütfen Proje Seçin','error')
		}else if (!formData.ticketPriorityId) {
			showToast('Lütfen Öncelik Seçin','error')
		}else if (!formData.ticketStatusId) {
			showToast('Lütfen Talep Durumunu Seçin','error')
		}else if (!formData.ticketTypeId) {
			showToast('Lütfen Talep Tipini Seçin','error')
		}else {
			saveTicket('/Ticket/AddTickets', {
				method: 'POST',
				data: formData
			}).then(res => {
				if (res.data.ok) {
					showToast('Yeni Görev Oluşturuldu', 'success')
					navigate('/tasks')
				}
			})
		}
		
	}
	return (
		<AnimatedSpan className='page-container d-flex flex-column'>
			<div className='card'>
				<div className='row'>
					<div className='col-md-12'>
						<div className='heading-2'>Görev Oluştur</div>
					</div>
				</div>
				<div className='w-100 d-flex flex-column gap-3'>
					<div className="row">
						<div className='col-md-12'>
							<input className='default-input' type='text' name='title' placeholder='Görev Başlığı' onChange={(e) => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }))} />
						</div>
					</div>
					<div className='row'>
						<div className='col-md-6'>
							<DefaultSelect
								placeholder='Proje'
								handleChange={(e) => handleDropdownChange(e)}
								selectOptions={projectsData?.map(p => ({ label: p.name, value: p.id, name: 'projectId' }))}
							/>
						</div>
						<div className='col-md-6'>
							<DefaultSelect
								placeholder='Talep Durumu'
								handleChange={(e) => handleDropdownChange(e)}
								selectOptions={taskStatuses?.map(p => ({ label: p.name, value: p.id, name: 'ticketStatusId' }))}
							/>
						</div>
					</div>
					<div className='row'>
						<div className='col-md-6'>
							<DefaultSelect
								placeholder='Öncelik'
								handleChange={(e) => handleDropdownChange(e)}
								selectOptions={priorities?.map(p => ({ label: p.name, value: p.id, name: 'ticketPriorityId' }))}
							/>
						</div>
						<div className='col-md-6'>
							<DefaultSelect
								placeholder='Talep Tipi'
								handleChange={(e) => handleDropdownChange(e)}
								selectOptions={taskTypes?.map(t => ({ label: t.name, value: t.id, name: 'ticketTypeId' }))}
							/>
						</div>
					</div>
					<div className='row'>
						<div className='col-12'>
							<RichEditor defaultContentState={formData.description} setState={(value) => setFormData(prev => ({ ...prev, description: value }))} />
						</div>
					</div>
					<div className='row'>
						<div className='col-md-12 d-flex justify-content-end gap-3'>
							<Link to={-1} className='btn-danger-outline'>
								Vazgeç
							</Link>
							<Button className='btn-success' title='Kaydet' handleClick={handleSubmit} />
						</div>
					</div>
				</div>
			</div>
		</AnimatedSpan>
	)
}

export default CreateTask